import React from "react";

import Title from "../../ui/Title/Title";

import { useDispatch, useSelector } from "react-redux";
import TelegramBtnIcon from "../../assets/icons/TelegramBtnIcon";
import Button from "../../ui/Button/Button";
import TextArea from "../../ui/TextArea/TextArea";
import styles from "./UsersMessageContainer.module.scss";
import { postAllUsersMessage } from "../../utils/api/actions/integrations/tgBot";

export default function UsersMessageContainer() {
  const dispatch = useDispatch();
  const [message, setMessage] = React.useState("");
  const [visibleSuccessMessage, setVisibleSuccessMessage] =
    React.useState(false);
  const { activeBot } = useSelector((state) => state.integration);

  const handlerMessageText = (e) => setMessage(e.target.value);

  const observeSendMessage = () => {
    setTimeout(() => {
      setVisibleSuccessMessage(false);
    }, 3000);
  };

  const handlerSendUsersMessage = () => {
    let dataMessage = {
      id: activeBot.activeBot.id,
      message,
    };
    dispatch(postAllUsersMessage(dataMessage));
    setMessage("");
    setVisibleSuccessMessage(true);
    observeSendMessage();
  };

  return (
    <div className={styles.container}>
      <Title title="Сообщение" className={styles.title} />
      <label className={styles.subtitle}>
        Сообщение будет отправлено всем пользователям
      </label>
      <TextArea
        classNameTextArea={styles.messageContainer}
        rows="7"
        placeholder="Сообщение"
        value={message}
        onChange={handlerMessageText}
      />
      <div className={styles.footer}>
        <Button
          leftIcon={<TelegramBtnIcon />}
          onClick={handlerSendUsersMessage}
          className={styles.sendButton}
          titleClassName={styles.titleSendButton}
          title="Отправить"
        />
        {visibleSuccessMessage && (
          <label className={styles.successMessage}>
            Сообщение отправлено всем пользователям
          </label>
        )}
      </div>
    </div>
  );
}
